export default __webpack_public_path__ + "images/logoInstytutum.12f47946666aa87b196f719d5a5ce933.svg"